(() => {
  const initAuraPolicy = () => {
    if (document.body.classList.contains('aura-policy-ready')) {
      return;
    }

    const container = document.querySelector(
      '.shopify-policy__container'
    );

    const body = document.querySelector(
      '.shopify-policy__body .rte'
    );

    const title = document.querySelector(
      '.shopify-policy__title'
    );

    if (!container || !body || !title) return;

    document.body.classList.add(
      'aura-policy-page',
      'aura-policy-ready'
    );

    /* ================================================================
       META BAR
       ================================================================ */

    const meta = document.createElement('div');
    meta.className = 'aura-policy-meta';

    meta.innerHTML = `
      <div class="aura-policy-meta__brand">
        AURA STORE
      </div>

      <button
        class="aura-policy-meta__print"
        type="button"
        aria-label="Imprimer cette politique"
      >
        <svg
          aria-hidden="true"
          viewBox="0 0 24 24"
          width="15"
          height="15"
          fill="none"
        >
          <path
            d="M7 8V3h10v5M7 17H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2M7 14h10v7H7v-7Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <span>Imprimer</span>
      </button>
    `;

    container.insertBefore(
      meta,
      title
    );

    meta
      .querySelector('.aura-policy-meta__print')
      ?.addEventListener(
        'click',
        () => window.print()
      );

    /* ================================================================
       CONTENT WRAPPER
       ================================================================ */

    const content = document.createElement('div');
    content.className = 'aura-policy-content';

    const originalNodes = Array.from(
      body.childNodes
    );

    originalNodes.forEach((node) => {
      content.appendChild(node);
    });

    body.appendChild(content);

    /* ================================================================
       HEADINGS
       ================================================================ */

    const headings = Array.from(
      content.querySelectorAll('h2')
    );

    const slugify = (text) => {
      return text
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[’']/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
    };

    const usedIds = new Set();

    headings.forEach((heading, index) => {
      let base =
        heading.id ||
        slugify(
          heading.textContent.trim()
        ) ||
        `section-${index + 1}`;

      let id = base;
      let number = 2;

      while (usedIds.has(id)) {
        id = `${base}-${number}`;
        number += 1;
      }

      usedIds.add(id);
      heading.id = id;
    });

    /* ================================================================
       TABLE OF CONTENTS
       ================================================================ */

    if (headings.length > 1) {
      const nav =
        document.createElement('nav');

      nav.className = 'aura-policy-toc';
      nav.setAttribute(
        'aria-label',
        'Sommaire'
      );

      nav.dataset.open = 'false';

      const tocItems = headings
        .map((heading, index) => {
          return `
            <li class="aura-policy-toc__item">
              <a
                class="aura-policy-toc__link"
                href="#${heading.id}"
              >
                ${heading.textContent.trim()}
              </a>
            </li>
          `;
        })
        .join('');

      nav.innerHTML = `
        <p class="aura-policy-toc__title">
          Sommaire
        </p>

        <button
          type="button"
          class="aura-policy-toc__toggle"
          aria-expanded="false"
        >
          <span>Sommaire</span>

          <svg
            class="aura-policy-toc__toggle-icon"
            aria-hidden="true"
            viewBox="0 0 24 24"
            width="16"
            height="16"
            fill="none"
          >
            <path
              d="m6 9 6 6 6-6"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <ul class="aura-policy-toc__list">
          ${tocItems}
        </ul>
      `;

      body.insertBefore(
        nav,
        content
      );

      const toggle = nav.querySelector(
        '.aura-policy-toc__toggle'
      );

      toggle?.addEventListener(
        'click',
        () => {
          const isOpen =
            nav.dataset.open === 'true';

          nav.dataset.open =
            isOpen ? 'false' : 'true';

          toggle.setAttribute(
            'aria-expanded',
            isOpen ? 'false' : 'true'
          );
        }
      );

      nav
        .querySelectorAll(
          '.aura-policy-toc__link'
        )
        .forEach((link) => {
          link.addEventListener(
            'click',
            () => {
              nav.dataset.open = 'false';

              toggle?.setAttribute(
                'aria-expanded',
                'false'
              );
            }
          );
        });

      /* Active section */

      const updateActive = () => {
        const offset =
          Math.max(
            140,
            window.innerHeight * 0.24
          );

        let active = headings[0];

        headings.forEach((heading) => {
          if (
            heading.getBoundingClientRect()
              .top <= offset
          ) {
            active = heading;
          }
        });

        nav
          .querySelectorAll(
            '.aura-policy-toc__link'
          )
          .forEach((link) => {
            const target =
              decodeURIComponent(
                link
                  .getAttribute('href')
                  .slice(1)
              );

            const isActive =
              target === active.id;

            link.classList.toggle(
              'is-active',
              isActive
            );

            if (isActive) {
              link.setAttribute(
                'aria-current',
                'location'
              );
            } else {
              link.removeAttribute(
                'aria-current'
              );
            }
          });
      };

      window.addEventListener(
        'scroll',
        updateActive,
        { passive: true }
      );

      updateActive();
    }

    /* ================================================================
       TABLE WRAPPERS
       ================================================================ */

    content
      .querySelectorAll('table')
      .forEach((table) => {
        if (
          table.parentElement?.classList
            .contains(
              'aura-policy-table-wrap'
            )
        ) {
          return;
        }

        const wrapper =
          document.createElement('div');

        wrapper.className =
          'aura-policy-table-wrap';

        table.parentNode.insertBefore(
          wrapper,
          table
        );

        wrapper.appendChild(table);
      });

    /* ================================================================
       BACK TOP
       ================================================================ */

    const backTop =
      document.createElement('button');

    backTop.className =
      'aura-policy-backtop';

    backTop.type = 'button';

    backTop.setAttribute(
      'aria-label',
      'Retour en haut'
    );

    backTop.innerHTML = `
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        width="17"
        height="17"
        fill="none"
      >
        <path
          d="M12 19V5M6.5 10.5 12 5l5.5 5.5"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `;

    document.body.appendChild(
      backTop
    );

    backTop.addEventListener(
      'click',
      () => {
        const reducedMotion =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

        container.scrollIntoView({
          behavior:
            reducedMotion
              ? 'auto'
              : 'smooth',
          block: 'start'
        });
      }
    );

    const updateBackTop = () => {
      backTop.classList.toggle(
        'is-visible',
        window.scrollY > 900
      );
    };

    window.addEventListener(
      'scroll',
      updateBackTop,
      { passive: true }
    );

    updateBackTop();
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAuraPolicy
    );
  } else {
    initAuraPolicy();
  }
})();